// extracted by mini-css-extract-plugin
export var image = "ErrorMessage-module--image--1fQAt";
export var wrapper = "ErrorMessage-module--wrapper--LTCe_";
export var spinAround = "ErrorMessage-module--spinAround--3b6VV";